<template>
	<span
		class="mention"
		:class="{ me: isMe, pointer: user }"
		@click="showUserCard"
	>
		{{
			userId === 'everyone'
				? $t('model_mentions_moniker_everyone')
				: user
				? `@${user.fullname}`
				: `@User #${this.userId}`
		}}
	</span>
</template>
<script>
export default {
	name: 'Mention',
	props: ['user', 'isMe', 'userId'],
	methods: {
		showUserCard() {
			if (!this.user) return false
			EventBus.$emit('openProfileCard', this.user)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.mention {
	color: #0c9ef4;
	background: rgba($pronto-blue, 0.1);
	&.me {
		background: rgba(#ffbb00, 0.18);
	}
}
</style>
